import React from 'react';

import ListView from '../shared/lists/ListView';
import MiscSaleItem from './MiscSaleItem';
import CustomTh from '../shared/table/CustomTh';

const MiscSaleList = ({
    addItem,
    canAdd,
    data: { items },
    editItem,
    fetchData
}) => {
    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <CustomTh width="100px" content="Date" />
                <CustomTh hide="md" content="Designer" />
                <CustomTh width="95px" hide="sm" content="Total" />
                <CustomTh width="95px" hide="lg" content="Deposit" />
                <CustomTh width="95px" hide="lg" content="Balance" />
                <CustomTh width="50px" content="Paid" />
                <CustomTh content="Description" />
                <CustomTh width="90px" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item, index) =>
        <MiscSaleItem
            editItem={editItem}
            fetchData={fetchData}
            item={item}
            key={index}
        />);

    return (
        <ListView
            addItem={addItem}
            canAdd={canAdd}
            itemName="Miscellaneous Sale"
            items={listItems}
            tableHead={tableHead}
        />);
}

export default MiscSaleList;